import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class MachineCreateFolderHandler {
  createFolder(nodeSelectionNodeData) {
    const machineStructureNodeset = getMachineStructureNodeset();

    const machineStructureFlatMap = machineStructureNodeset.getFlatMap();

    const selectedNode = machineStructureFlatMap.get(
      nodeSelectionNodeData.nodeId,
    );

    const newFolder = new OurNode({
      name: "New Folder",
      node_type: "FOLDER",
      selected: false,
      visible: true,
      collapsed: false,
      neighborAbove: null,
      neighborBelow: null,
      parent: selectedNode,
      updateChildren: false,
    });

    selectedNode.appendNode(newFolder);
    const singleRootNode = selectedNode.returnRootNodeFromOurNode();
    machineStructureNodeset.setRootNode(singleRootNode);
    const flatMap = singleRootNode.createMapFromOurNodeTree();
    machineStructureNodeset.setFlatMap(flatMap);

    return newFolder;
  }
}
